import { c as _c } from "react/compiler-runtime";
import { Badge, Button, Divider, Stack, Typography } from '@mui/material';
import { Link } from '@/components/shared/link';
import { ApprovalDot } from './ApprovalDots';
import { toneColors } from './constants';
import { TextDetailsTuple } from '../text/textDetailsTuple';
export const ApprovalDetailsTooltip = t0 => {
  const $ = _c(13);
  const {
    awaitingApprovalCount,
    readyToApplyCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "395px",
      paddingY: "24px",
      gap: "12px",
      bgcolor: "background.primary",
      borderRadius: "4px",
      boxShadow: 10
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography variant="subtitle2" sx={{
      color: "text.secondary",
      paddingX: "24px"
    }}>You have requests that need your attention</Typography>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== awaitingApprovalCount) {
    t3 = !!awaitingApprovalCount && <ApprovalRow title="Awaiting approval" description="Submitted requests waiting for your review" count={awaitingApprovalCount} color={toneColors.pending.fg} />;
    $[2] = awaitingApprovalCount;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== readyToApplyCount) {
    t4 = !!readyToApplyCount && <ApprovalRow title="Ready to apply" description="Your approved requests waiting for action" count={readyToApplyCount} color={toneColors.apply.fg} />;
    $[4] = readyToApplyCount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Stack>{t3}{t4}</Stack>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Button href="/action-approvals" LinkComponent={Link} sx={{
      width: "max-content",
      alignSelf: "center"
    }} variant="text" color="primary">View All Action Requests</Button>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5) {
    t8 = <Stack className="dark" sx={t1}>{t2}{t5}{t6}{t7}</Stack>;
    $[11] = t5;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
const ApprovalRow = t0 => {
  const $ = _c(16);
  const {
    title,
    description,
    count,
    color
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      paddingX: "24px",
      paddingY: "12px",
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      gap: "12px",
      minWidth: 0
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== color) {
    t3 = <ApprovalDot color={color} />;
    $[2] = color;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description || $[5] !== title) {
    t4 = <TextDetailsTuple primaryProp={title} secondaryProp={description} />;
    $[4] = description;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <Stack direction="row" sx={t2}>{t3}{t4}</Stack>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      mr: "12px"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== count) {
    t7 = <Badge badgeContent={count} color="primary" sx={t6} />;
    $[11] = count;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <Stack direction="row" sx={t1}>{t5}{t7}</Stack>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};